var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container, attrs: { "data-sku": _vm.sku } },
    [
      _c(
        "div",
        { class: _vm.$style.left },
        [
          _c("NsImage", {
            class: _vm.$style["product-image"],
            attrs: {
              src: _vm.image.src,
              alt: _vm.image.alt,
              "fallback-src": _vm.imageFallbackSrc,
              "maintain-ratio": "1x1",
              "image-fit": "contain",
              "size-lock": "2",
            },
          }),
          _vm._v(" "),
          _c("div", {
            class: _vm.$style["product-title"],
            domProps: { innerHTML: _vm._s(_vm.title) },
          }),
          _vm._v(" "),
          _vm._t("left"),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$style.right }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }